import { generateGradYearOptions } from './utils/dateUtils';

export const page = {
    header: "",
    subheader: "",
    total_pages: 3
}

export const page1 = {
    q1: {
        label: "I am a...",
        info: "Choose the option that best describes you",
        type: "radio",
        id: "userType",
        required: true,
        options: [
            "Student",
            "Parent/Guardian",
            "Graduate School Applicant", // the label to this option gets replaced through the index.css file
            "School administrator/Counselor",
            "Employer/Company representative",
            "Other"
        ]
    },
    q2: {
        label: "Currently",
        info: "Which best describes you?",
        type: "dropdown",
        id: "studentGrade",
        required: true,
        options: [
            { 
                value: 1,
                label: "In high school"
            },
            {
                value:  2,
                label: "In college, looking to transfer"
            },
            // I removed this option since we handle this differently now - Sandro P.
            //{
            //    value:  3,
            //    label: "In college, interested in graduate admissions"
            //},
            {
                value:  4,
                label: "In middle school"
            },
            {
                value:  5,
                label: "Taking a gap year"
            },
        ],
        options_grad: [
            {
                value: 7,
                label: "UK/U.S. Master's"
            },
            {
                value: 8,
                label: "Ph.D."
            },
            {
                value: 9,
                label: "MBA"
            },
            {
                value: 10,
                label: "Professional school (i.e. medical, dental, law, or nursing schools)"
            },
            {
                value: 6,
                label: "Current high school student"
            }
        ]
    }
}

export const page2_student_q = {
    headline: 'Enter your contact info',
    headline_sub: 'Enter your parent\'s info',
    firstName: {
        label: "First name",
        info: "John",
        type: "text",
        id: "firstName",
        required: true
    },
    lastName: {
        label: "Last name",
        info: "Doe",
        type: "text",
        id: "lastName",
        required: true
    },
    email: {
        label: "Email",
        info: "name@email.com",
        type: "email",
        id: "email",
        required: true
    },
    phone: {
        label: "Phone",
        info: "+1 (555) 555-1234",
        type: "tel",
        id: "phone",
        required: true
    },
    graduationYr: {
        info: "Graduation year",
        type: "dropdown",
        id: "gradYear",
        required: false,
        options: [
            { value: 1, label: "2024" },
            { value: 2, label: "2025" },
            { value: 3, label: "2026" },
            { value: 4, label: "2027" },
            { value: 5, label: "2028" }
        ],
        options_grad: generateGradYearOptions()
    },
    highSchool: {
        label: "School name",
        info: "Enter your school's name",
        info_secondary: "Enter your child's school name",
        type: "text",
        id: "highschool",
        required: true
    },
    helpInfo: {
        label: "Please let us know how we can help you",
        info: "Enter your answer here",
        type: "text",
        id: "help",
        required: true
    },
    firstName_sub: {
        label: "First name",
        info: "John",
        type: "text",
        id: "firstName_sub",
        required: true
    },
    lastName_sub: {
        label: "Last name",
        info: "Doe",
        type: "text",
        id: "lastName_sub",
        required: true
    },
    email_sub: {
        label: "Email",
        info: "name@email.com",
        type: "email",
        id: "email_sub",
        required: true
    },
    phone_sub: {
        label: "Phone",
        info: "+1 (555) 555-1234",
        type: "tel",
        id: "phone_sub",
        required: true

    },
}

export const page2_parent_q = {
    headline: 'Enter your contact info',
    firstName: {
        label: "First name",
        info: "John",
        type: "text",
        id: "firstName",
        required: true
    },
    lastName: {
        label: "Last name",
        info: "Doe",
        type: "text",
        id: "lastName",
        required: true
    },
    email: {
        label: "Email",
        info: "name@email.com",
        type: "email",
        id: "email",
        required: true
    },
    phone: {
        label: "Phone",
        info: "+1 (555) 555-1234",
        type: "tel",
        id: "phone",
        required: true
    },
    helpInfo: {
        label: "Please let us know how we can help you",
        info: "Enter your answer here",
        type: "text",
        id: "help",
        required: true
    },
    headline_sub: 'Enter your student\'s info',
    firstName_sub: {
        label: "First name",
        info: "John",
        type: "text",
        id: "firstName_sub",
        required: false
    },
    lastName_sub: {
        label: "Last name",
        info: "Doe",
        type: "text",
        id: "lastName_sub",
        required: false
    },
    email_sub: {
        label: "Email",
        info: "name@email.com",
        type: "email",
        id: "email_sub",
        required: false
    },
    phone_sub: {
        label: "Phone",
        info: "+1 (555) 555-1234",
        type: "tel",
        id: "phone_sub",
        required: false
    },
    graduationYr: {
        // label: "Graduation year",
        info: "Graduation year",
        type: "dropdown",
        id: "gradYear",
        required: false,
        options: [
            { 
                value: 1,
                label: "2024"
            },
            {
                value:  2,
                label: "2025"
            },
            {
                value:  3,
                label: "2026"
            },
            {
                value:  4,
                label: "2027"
            },
            {
                value:  5,
                label: "2028"
            }
        ],
    },
    highSchool: {
        label: "School name",
        info: "Enter your child's school name",
        info_secondary: "Enter the student's school name",
        type: "text",
        id: "highschool",
        required: false
    },
}

export const page3 = {
    headline: "Book your initial consultation",
    q1: {
        // label: "How did you hear about us?",
        info: "How did you hear about us?",
        type: "dropdown",
        id: "leadSource",
        required: false,
        options: [
            "Instagram",
            "Twitter",
            "Facebook",
            "Advertisement",
            "Google search",
            "LinkedIn",
            "Someone referred you"
        ]
    },
    q2: {
        label: "Name",
        info: "What's their name?",
        type: "text",
        id: "referralSource",
        required: true,
    },
    q3: {
        label: "",
        info: "When are you looking to enroll in admissions counseling?",
        id: "timeline",
        required: false,
        type: "dropdown",
        options: [
            "As soon as possible",
            "This month",
            "In 3 months",
            "Not sure"
        ]
    }
}